// Social media links
export const socialLinks = {
  instagram: "https://www.instagram.com/eevn_band",
  youtube: "https://www.youtube.com/@eevn_band"
};

// Music platform links (artist profiles)
export const musicPlatforms = {
  spotify: "https://open.spotify.com/artist/5iqIRsKuJgtNtp2eCbkBVv",
  appleMusic: "https://music.apple.com/cz/artist/eevn/1841254589",
  youtube: "https://www.youtube.com/@eevn_band",
  youtubeMusic: "https://music.youtube.com/channel/UC3MDZXxiz3m3ENnWQMEScaA?si=FGjY7Av_YtSZOrQR",
  tidal: "https://tidal.com/artist/67380595"
};

// Contact email address
export const contactEmail = "info@eevn.band";
